import LocalizedStrings from 'react-localization';

//English languague configuration
import englishAccount from './language_configuration/english/account/account';
import englishBehaviorIndicators from './language_configuration/english/behavior/behaviorIndicators';
import englishDetailBehavior from './language_configuration/english/behavior/detailBehavior';
import englishDetailFatigue from './language_configuration/english/fatigue/detailFatigue';
import englishDetailRoadWarning from './language_configuration/english/road_warning/detailRoadWarning';
import englishDetailWaitingTimes from './language_configuration/english/detail/detailWaitingTimes';
import englishDriverBehavior from './language_configuration/english/behavior/driverBehavior';
import englishDriverFatigue from './language_configuration/english/fatigue/driverFatigue';
import englishDriverRoadWarning from './language_configuration/english/road_warning/driverRoadWarning';
import englishDynamicList from './language_configuration/english/dynamic_list';
import englishError from './language_configuration/english/error';
import englishFatigueIndicators from './language_configuration/english/fatigue/fatigueIndicators';
import englishFilter from './language_configuration/english/filters';
import englishFlows from './language_configuration/english/flows/';
import englishLoading from './language_configuration/english/loading/';
import englishLogin from './language_configuration/english/login/';
import englishNav from './language_configuration/english/nav';
import englishSummary from './language_configuration/english/summary';
import englishSurvey from './language_configuration/english/survey/';
import englishTaskManager from './language_configuration/english/task_manager/taskManager';
import englishTour from './language_configuration/english/tour/';
import englishUserProfile from './language_configuration/english/user_profile/';

//Spanish languague configuration
import spanishAccount from './language_configuration/spanish/account/account';
import spanishBehaviorIndicators from './language_configuration/spanish/behavior/behaviorIndicators';
import spanishDetailBehavior from './language_configuration/spanish/behavior/detailBehavior';
import spanishDetailFatigue from './language_configuration/spanish/fatigue/detailFatigue';
import spanishDetailRoadWarning from './language_configuration/spanish/road_warning/detailRoadWarning';
import spanishDetailWaitingTimes from './language_configuration/spanish/detail/detailWaitingTimes';
import spanishDriverBehavior from './language_configuration/spanish/behavior/driverBehavior';
import spanishDriverFatigue from './language_configuration/spanish/fatigue/driverFatigue';
import spanishDriverRoadWarning from './language_configuration/spanish/road_warning/driverRoadWarning';
import spanishDynamicList from './language_configuration/spanish/dynamic_list';
import spanishError from './language_configuration/spanish/error';
import spanishFatigueIndicators from './language_configuration/spanish/fatigue/fatigueIndicators';
import spanishFilter from './language_configuration/spanish/filters';
import spanishFlows from './language_configuration/spanish/flows/';
import spanishLoading from './language_configuration/spanish/loading/';
import spanishLogin from './language_configuration/spanish/login/';
import spanishNav from './language_configuration/spanish/nav';
import spanishSummary from './language_configuration/spanish/summary';
import spanishSurvey from './language_configuration/spanish/survey/';
import spanishTaskManager from './language_configuration/spanish/task_manager/taskManager';
import spanishTour from './language_configuration/spanish/tour/';
import spanishUserProfile from './language_configuration/spanish/user_profile/';

//Portuguese languague configuration
import portugueseAccount from './language_configuration/portuguese/account/account';
import portugueseBehaviorIndicators from './language_configuration/portuguese/behavior/behaviorIndicators';
import portugueseDetailBehavior from './language_configuration/portuguese/behavior/detailBehavior';
import portugueseDetailFatigue from './language_configuration/portuguese/fatigue/detailFatigue';
import portugueseDetailRoadWarning from './language_configuration/portuguese/road_warning/detailRoadWarning';
import portugueseDetailWaitingTimes from './language_configuration/portuguese/detail/detailWaitingTimes';
import portugueseDriverBehavior from './language_configuration/portuguese/behavior/driverBehavior';
import portugueseDriverFatigue from './language_configuration/portuguese/fatigue/driverFatigue';
import portugueseDriverRoadWarning from './language_configuration/portuguese/road_warning/driverRoadWarning';
import portugueseDynamicList from './language_configuration/portuguese/dynamic_list';
import portugueseError from './language_configuration/portuguese/error';
import portugueseFatigueIndicators from './language_configuration/portuguese/fatigue/fatigueIndicators';
import portugueseFilter from './language_configuration/portuguese/filters';
import portugueseFlows from './language_configuration/portuguese/flows/';
import portugueseLoading from './language_configuration/portuguese/loading/';
import portugueseLogin from './language_configuration/portuguese/login/';
import portugueseNav from './language_configuration/portuguese/nav';
import portugueseSummary from './language_configuration/portuguese/summary';
import portugueseSurvey from './language_configuration/portuguese/survey/';
import portugueseTaskManager from './language_configuration/portuguese/task_manager/taskManager';
import portugueseTour from './language_configuration/portuguese/tour/';
import portugueseUserProfile from './language_configuration/portuguese/user_profile/';

//Escondida languague configuration
import escondidaAccount from './language_configuration/escondida/account/account';
import escondidaBehaviorIndicators from './language_configuration/escondida/behavior/behaviorIndicators';
import escondidaDetailBehavior from './language_configuration/escondida/behavior/detailBehavior';
import escondidaDetailFatigue from './language_configuration/escondida/fatigue/detailFatigue';
import escondidaDetailRoadWarning from './language_configuration/escondida/road_warning/detailRoadWarning';
import escondidaDetailWaitingTimes from './language_configuration/escondida/detail/detailWaitingTimes';
import escondidaDriverBehavior from './language_configuration/escondida/behavior/driverBehavior';
import escondidaDriverFatigue from './language_configuration/escondida/fatigue/driverFatigue';
import escondidaDriverRoadWarning from './language_configuration/escondida/road_warning/driverRoadWarning';
import escondidaDynamicList from './language_configuration/escondida/dynamic_list';
import escondidaError from './language_configuration/escondida/error';
import escondidaFatigueIndicators from './language_configuration/escondida/fatigue/fatigueIndicators';
import escondidaFilter from './language_configuration/escondida/filters';
import escondidaFlows from './language_configuration/escondida/flows/';
import escondidaLoading from './language_configuration/escondida/loading/';
import escondidaLogin from './language_configuration/escondida/login/';
import escondidaNav from './language_configuration/escondida/nav';
import escondidaSummary from './language_configuration/escondida/summary';
import escondidaSurvey from './language_configuration/escondida/survey/';
import escondidaTaskManager from './language_configuration/escondida/task_manager/taskManager';
import escondidaTour from './language_configuration/escondida/tour/';
import escondidaUserProfile from './language_configuration/escondida/user_profile/';

const strings = new LocalizedStrings({
  es: {
    all: 'TODOS',
    account: spanishAccount,
    behavior_indicators: spanishBehaviorIndicators,
    detail_behavior: spanishDetailBehavior,
    detail_fatigue: spanishDetailFatigue,
    detail_roadwarning: spanishDetailRoadWarning,
    detail_waiting_times: spanishDetailWaitingTimes,
    driver_behavior: spanishDriverBehavior,
    driver_fatigue: spanishDriverFatigue,
    driver_roadwarning: spanishDriverRoadWarning,
    dynamicList: spanishDynamicList,
    error: spanishError,
    fatigue_indicators: spanishFatigueIndicators,
    filter: spanishFilter,
    flows: spanishFlows,
    load: spanishLoading,
    login: spanishLogin,
    nav: spanishNav,
    summary: spanishSummary,
    survey: spanishSurvey,
    tasks_manager: spanishTaskManager,
    tour: spanishTour,
    user_profile: spanishUserProfile
  },
  en: {
    all: 'ALL',
    account: englishAccount,
    behavior_indicators: englishBehaviorIndicators,
    detail_behavior: englishDetailBehavior,
    detail_fatigue: englishDetailFatigue,
    detail_roadwarning: englishDetailRoadWarning,
    detail_waiting_times: englishDetailWaitingTimes,
    driver_behavior: englishDriverBehavior,
    driver_fatigue: englishDriverFatigue,
    driver_roadwarning: englishDriverRoadWarning,
    dynamicList: englishDynamicList,
    error: englishError,
    fatigue_indicators: englishFatigueIndicators,
    filter: englishFilter,
    flows: englishFlows,
    load: englishLoading,
    login: englishLogin,
    nav: englishNav,
    summary: englishSummary,
    survey: englishSurvey,
    tasks_manager: englishTaskManager,
    tour: englishTour,
    user_profile: englishUserProfile
  },
  pt: {
    all: 'TODOS',
    account: portugueseAccount,
    behavior_indicators: portugueseBehaviorIndicators,
    detail_behavior: portugueseDetailBehavior,
    detail_fatigue: portugueseDetailFatigue,
    detail_roadwarning: portugueseDetailRoadWarning,
    detail_waiting_times: portugueseDetailWaitingTimes,
    driver_behavior: portugueseDriverBehavior,
    driver_fatigue: portugueseDriverFatigue,
    driver_roadwarning: portugueseDriverRoadWarning,
    dynamicList: portugueseDynamicList,
    error: portugueseError,
    fatigue_indicators: portugueseFatigueIndicators,
    filter: portugueseFilter,
    flows: portugueseFlows,
    load: portugueseLoading,
    login: portugueseLogin,
    nav: portugueseNav,
    summary: portugueseSummary,
    survey: portugueseSurvey,
    tasks_manager: portugueseTaskManager,
    tour: portugueseTour,
    user_profile: portugueseUserProfile
  },
  escondida: {
    all: 'TODOS',
    account: escondidaAccount,
    behavior_indicators: escondidaBehaviorIndicators,
    detail_behavior: escondidaDetailBehavior,
    detail_fatigue: escondidaDetailFatigue,
    detail_roadwarning: escondidaDetailRoadWarning,
    detail_waiting_times: escondidaDetailWaitingTimes,
    driver_behavior: escondidaDriverBehavior,
    driver_fatigue: escondidaDriverFatigue,
    driver_roadwarning: escondidaDriverRoadWarning,
    dynamicList: escondidaDynamicList,
    error: escondidaError,
    fatigue_indicators: escondidaFatigueIndicators,
    filter: escondidaFilter,
    flows: escondidaFlows,
    load: escondidaLoading,
    login: escondidaLogin,
    nav: escondidaNav,
    summary: escondidaSummary,
    survey: escondidaSurvey,
    tasks_manager: escondidaTaskManager,
    tour: escondidaTour,
    user_profile: escondidaUserProfile
  }
});

export default strings;



// WEBPACK FOOTER //
// ./source/client/components/locales/index.js